(() => {
  if (customElements.get('product-form')) return;

  class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.submitButton = this.form.querySelector('[name="add"]');
      this.cartDrawer = document.querySelector('cart-drawer');
      this.productBar = document.querySelector(`#ProductBar-${this.dataset.sectionId}`);

      this.variantData = this.loadVariantData();
      this.lastVariantId = null;
      this.pollInterval = null;

      this.setupVariantWatcher();
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    }

    loadVariantData() {
      const dataEl = document.getElementById(`highlighted-variant-data-${this.dataset.sectionId}`);
      if (!dataEl) return null;
      try {
        return JSON.parse(dataEl.textContent).variants;
      } catch (e) {
        return null;
      }
    }

    getVariantInput() {
      return document.querySelector(`.product__variant-picker input[name="id"]`);
    }

    setupVariantWatcher() {
      if (!this.variantData) return;
      const variantInput = this.getVariantInput();
      if (!variantInput) return;

      this.lastVariantId = variantInput.value;
      this.updatePreorderState(this.lastVariantId);

      this.pollInterval = setInterval(() => {
        if (variantInput.value !== this.lastVariantId) {
          this.lastVariantId = variantInput.value;
          this.updatePreorderState(variantInput.value);
        }
      }, 100);
    }

    disconnectedCallback() {
      if (this.pollInterval) clearInterval(this.pollInterval);
    }

    updatePreorderState(variantId) {
      const variant = this.variantData ? this.variantData[variantId] : null;
      if (!variant) return;

      const isPreorder = variant.pre_order || (variant.inventory_quantity <= 0 && variant.inventory_policy === 'continue');

      if (isPreorder) {
        this.setAttribute('data-has-preorder', '');
      } else {
        this.removeAttribute('data-has-preorder');
      }

      const preorderInput = this.form.querySelector('input.preorder-property');
      if (preorderInput) {
        preorderInput.disabled = !isPreorder;
      }

      if (isPreorder) {
        this.setButtonText(window.variantStrings?.preOrder);
        this.setButtonDisabled(false);
      } else if (!variant.available) {
        this.setButtonText(window.variantStrings?.soldOut || 'Sold out');
        this.setButtonDisabled(true);
      } else {
        const text = this.hasAttribute('data-has-selling-plan')
          ? (window.variantStrings?.addSubscriptionToCart || 'Add subscription to cart')
          : (window.variantStrings?.addToCart || 'Add to cart');
        this.setButtonText(text);
        this.setButtonDisabled(false);
      }

      const sectionEl = document.getElementById(`shopify-section-${this.dataset.sectionId}`);
      const inventoryNotice = sectionEl?.querySelector('[data-inventory-notice]');
      const preorderWarning = document.getElementById(`PreorderWarning-${this.dataset.sectionId}`);

      if (inventoryNotice) {
        const preorderContent = inventoryNotice.querySelector('.inventory-notice__preorder');
        const stockContent = inventoryNotice.querySelector('.inventory-notice__stock');
        const threshold = parseInt(inventoryNotice.dataset.inventoryThreshold) || 5;
        const shouldShow = isPreorder || (variant.inventory_quantity <= threshold && variant.available && variant.inventory_management === 'shopify');

        inventoryNotice.classList.toggle('hidden', !shouldShow);
        if (preorderContent) preorderContent.hidden = !isPreorder;
        if (stockContent) stockContent.hidden = isPreorder;
      }

      if (preorderWarning) {
        preorderWarning.hidden = !isPreorder;
      }
    }

    setButtonText(text) {
      [this.submitButton, this.productBar?.querySelector('[name="add"]')].forEach(btn => {
        if (!btn) return;
        if (btn.tagName === 'INPUT') btn.value = text;
        else btn.textContent = text;
      });
    }

    setButtonDisabled(disabled) {
      [this.submitButton, this.productBar?.querySelector('[name="add"]')].forEach(btn => {
        if (!btn) return;
        if (disabled) btn.setAttribute('disabled', 'disabled');
        else btn.removeAttribute('disabled');
      });
    }

    onSubmitHandler(event) {
      event.preventDefault();
      const purchaseOptions = document.querySelector('purchase-options');
      if (!!purchaseOptions && !purchaseOptions.isOneTimePurchase() && !this.hasAttribute('data-has-selling-plan')) {
        purchaseOptions.showError();
        return;
      }

      this.submitButton.classList.add('disabled');
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      const formData = new FormData(this.form);
      formData.append('sections', this.cartDrawer.getSectionsToRender().map(s => s.section));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then(r => r.json())
        .then(response => {
          if (response.status) {
            this.handleErrorMessage(response.message);
            return;
          }
          this.cartDrawer.renderContents(response);
          const counter = document.querySelector('.cart-drawer__title-counter');
          if (counter) counter.innerHTML = parseInt(counter.innerHTML) + 1;
        })
        .catch(console.error)
        .finally(() => this.submitButton.classList.remove('disabled'));
    }

    handleErrorMessage(errorMessage = false) {
      const errorWrapper = this.querySelector('[data-error-wrapper]');
      if (!errorWrapper) return;
      errorWrapper.classList.toggle('hidden', !errorMessage);
      errorWrapper.textContent = errorMessage || '';
      setTimeout(() => errorWrapper.classList.add('hidden'), 5000);
    }

    toggleAddButton(disable, text) {
      [this.submitButton, this.productBar?.querySelector('[name="add"]')].forEach(btn => {
        if (!btn) return;
        if (disable) {
          btn.setAttribute('disabled', 'disabled');
          if (text) btn.textContent = text;
        } else {
          btn.removeAttribute('disabled');
          btn.textContent = this.hasAttribute('data-has-preorder')
            ? 'Dispatched September'
            : this.hasAttribute('data-has-selling-plan')
              ? window.variantStrings?.addSubscriptionToCart || 'Add subscription to cart'
              : window.variantStrings?.addToCart || 'Add to cart';
        }
      });
    }
  }

  customElements.define('product-form', ProductForm);
})();